<template>
  <div class="question_slider">
    <h5 class="mb-3" v-html="question.the_question"></h5>

    <RangeSlider
      v-if="response"
      :min="question.min_value"
      :max="question.max_value"
      :step="question.step_value"
      :value="response.value_answer"
      :edit_mode="false"
    />

    <div class="whisper" v-else>No response yet</div>
  </div>
</template>

<script lang="ts">
import RangeSlider from '@/survey/components/RangeSlider.vue'
import { mapState } from 'pinia'
import { useSurveyResponseStore } from '@app/stores/SurveyResponseStore.ts'

export default {
  components: { RangeSlider },
  props: ['question', 'recipient_id'],
  computed: {
    ...mapState(useSurveyResponseStore, ['surveyResponses']),
    response() {
      return this.surveyResponses.find(
        (r) => r.question_id === this.question.id && r.recipient_id === Number(this.recipient_id),
      )
    },
  },
}
</script>
